__turbopack_context__.v({
  "button": "style-module-scss-module__Mf7FxG__button",
  "content": "style-module-scss-module__Mf7FxG__content",
  "image": "style-module-scss-module__Mf7FxG__image",
  "text": "style-module-scss-module__Mf7FxG__text",
  "wrapper": "style-module-scss-module__Mf7FxG__wrapper",
});
